import React from 'react'
import SbEditable from 'storyblok-react'
import RichText from '@/utils/RichText'
import { Button } from '@/components/ui/button'

interface Props {
  blok: StoryblokComponent & {
    has_gradient_background: boolean
    title: Record<string, string>
    content: string
    action_url: string
    action_cta_text: string
    marginTop?: number
    marginBottom?: number
  }
}

export const CTACardBlock = ({ blok }: Props) => {
  const marginTopClass = blok.marginTop ? `${blok.marginTop}px` : ''
  const marginBottomClass = blok.marginBottom ? `${blok.marginBottom}px` : ''

  return (
    <SbEditable content={blok} key={blok._uid}>
      <div
        data-testid="cta-card-container"
        style={{
          marginTop: marginTopClass,
          marginBottom: marginBottomClass,
        }}
      >
        <div
          className={`relative px-4 ${blok.has_gradient_background ? 'py-12 sm:py-20' : 'py-8 sm:py-12'} sm:px-8 md:px-12 lg:px-20 flex text-center justify-center bg-cover bg-center ${blok.has_gradient_background ? 'min-h-[320px] sm:min-h-[400px] lg:min-h-[500px] lg:aspect-[1.130/0.7]' : 'min-h-[280px] sm:min-h-[320px] lg:min-h-[400px]'} rounded-lg overflow-hidden`}
          style={{
            backgroundImage: blok.has_gradient_background ? 'url(/cloud-gradient.svg)' : 'none',
            backgroundPosition: 'center',
            backgroundSize: 'cover',
          }}
        >
          <div className="relative z-10 mx-auto max-w-3xl flex flex-col items-center justify-center">
            <div className="prose mb-4 font-display text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-medium ">
              <RichText>{blok.title}</RichText>
            </div>

            <div className="mt-4 sm:mt-8 px-4 sm:px-0">
              <p className="font-display text-darkblue mx-auto mb-6 sm:mb-8 text-base sm:text-lg">
                {blok.content}
              </p>
            </div>

            <Button to={blok.action_url} title={blok.action_cta_text}>
              {blok.action_cta_text}
            </Button>
          </div>
        </div>
      </div>
    </SbEditable>
  )
}

CTACardBlock.displayName = 'CTACardBlock'
